/**
 * @generated SignedSource<<c8c55cb5e438dc3c8f86a86d2fea01e7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type NovaStudioPageDeployDirectoryQuery$variables = {};
export type NovaStudioPageDeployDirectoryQuery$data = {
  readonly viewer: {
    readonly missionControlData: {
      readonly id: string;
      readonly companies: ReadonlyArray<{
        readonly id: string;
        readonly companyId: number | null;
        readonly name: string | null;
        readonly accessBlocked: boolean | null;
      } | null> | null;
      readonly forecastPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly email: string | null;
      } | null> | null;
      readonly otherPersons: ReadonlyArray<{
        readonly id: string;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly email: string | null;
        readonly companyId: string;
      } | null> | null;
    } | null;
  } | null;
};
export type NovaStudioPageDeployDirectoryQuery = {
  variables: NovaStudioPageDeployDirectoryQuery$variables;
  response: NovaStudioPageDeployDirectoryQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "companyId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "MissionControlDataType",
  "kind": "LinkedField",
  "name": "missionControlData",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlCompanyType",
      "kind": "LinkedField",
      "name": "companies",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessBlocked",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlImpersonatePersonType",
      "kind": "LinkedField",
      "name": "forecastPersons",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlImpersonatePersonType",
      "kind": "LinkedField",
      "name": "otherPersons",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/),
        (v4/*: any*/),
        (v1/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NovaStudioPageDeployDirectoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NovaStudioPageDeployDirectoryQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "afe8ba53db06959285cb9df420e220e4",
    "id": null,
    "metadata": {},
    "name": "NovaStudioPageDeployDirectoryQuery",
    "operationKind": "query",
    "text": "query NovaStudioPageDeployDirectoryQuery {\n  viewer {\n    missionControlData {\n      id\n      companies {\n        id\n        companyId\n        name\n        accessBlocked\n      }\n      forecastPersons {\n        id\n        firstName\n        lastName\n        email\n      }\n      otherPersons {\n        id\n        firstName\n        lastName\n        email\n        companyId\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "094e619ee2878de9405645fd3a9bc183";

export default node;
